import React from "react";
import config from "../../helper/config";
import { customerConstants } from "../../helper/constants.js";

import Footer from "../../components/admin/layouts/Footer.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

export default function LoginColumn({ children }) {
  const customer = getCustomerFeatureFlag();
  let footerText;

  switch (customer) {
    case customerConstants.EXO_CUSTOMER1:
      footerText =
        "Copyright 2025 Edsider. All Rights Reserved. Designed and Developed by Infinity Innovators (Pvt) Ltd";
      break;
    case customerConstants.EXO_CUSTOMER2:
      footerText =
        "Copyright 2025 All Rights Reserved. Powered by EdSider. Supported by Infinity Innovators (Pvt) Ltd";
      break;
    default:
      footerText =
        "Copyright 2025 All Rights Reserved. Designed and Developed by Infinity Innovators (Pvt) Ltd";
      break;
  }

  return (
    <div className="teacher-login-layout">
      <div className="teacher-login-page">
        <div className="teacher-login-main">{children}</div>
      </div>

       {/* Footer */}
        <div className="footer-section">
          <Footer />
        </div>
    </div>
  );
}